export const extractGeocoderResults = async (
  geolocation: google.maps.GeocoderResult,
  options?: {
    originalAddress?: string;
    preserveOriginalAddressDetails?: boolean;
  },
) => {
  if (!geolocation) {
    throw new Error("No geolocation data found");
  }

  const isPartialResult = !geolocation?.geometry?.location;

  const poBoxPattern = /\b[P|p]\.?\s*[O|o]\.?\s*[B|b][Oo][Xx]\.?\s+\d+\b/;
  const poBoxMatch = options?.originalAddress
    ? poBoxPattern.exec(options.originalAddress)
    : null;
  const hasPOBox = !!poBoxMatch;

  const suitePattern = /\b(?:suite|ste|unit|apt|apartment|#)\s*[a-z0-9-]+\b/i;

  let suiteInfo = null;
  if (options?.originalAddress) {
    suiteInfo = suitePattern.exec(options.originalAddress);
  }
  const hasManualSuite = !!suiteInfo;

  let streetNumber = "";
  let route = "";
  let city = "";
  let state = "";
  let zip = "";
  let country = "";
  let county = "";
  let apt = "";

  if (geolocation?.address_components) {
    for (const addressComponent of geolocation.address_components) {
      if (addressComponent.types.includes("street_number")) {
        streetNumber = addressComponent.short_name;
      } else if (addressComponent.types.includes("route")) {
        route = addressComponent.short_name;
      } else if (addressComponent.types.includes("subpremise")) {
        apt = addressComponent.short_name;
      } else if (addressComponent.types.includes("locality")) {
        city = addressComponent.long_name;
      } else if (
        addressComponent.types.includes("administrative_area_level_1")
      ) {
        state = addressComponent.short_name;
      } else if (
        addressComponent.types.includes("administrative_area_level_2")
      ) {
        county = addressComponent.long_name;
      } else if (addressComponent.types.includes("postal_code")) {
        zip = addressComponent.long_name;
      } else if (addressComponent.types.includes("country")) {
        country = addressComponent.short_name;
      }
    }

    if (!city) {
      for (const addressComponent of geolocation.address_components) {
        if (
          addressComponent.types.some((type: any) =>
            ["neighborhood", "administrative_area_level_3"].includes(type),
          )
        ) {
          city = addressComponent.long_name;
        }
      }
    }
  }

  if (hasManualSuite && options?.preserveOriginalAddressDetails && suiteInfo) {
    apt = suiteInfo[0];
  }

  let addressLine1 = "";
  if (hasPOBox && options?.preserveOriginalAddressDetails) {
    addressLine1 = poBoxMatch[0];
  } else {
    addressLine1 = `${streetNumber} ${route}`.trim();

    if (apt && options?.preserveOriginalAddressDetails) {
      addressLine1 = `${addressLine1} ${apt}`;
    }
  }

  const latLng = !isPartialResult
    ? {
        lat: geolocation.geometry.location.lat(),
        lng: geolocation.geometry.location.lng(),
      }
    : { lat: 0, lng: 0 };

  return {
    zip,
    streetNumber,
    route,
    apt,
    city,
    country,
    county,
    state,
    latLng,
    formattedAddress: geolocation.formatted_address || options?.originalAddress,
    addressLine1,
    isPOBox: hasPOBox,
  };
};
